<template>
    <div class="options-navig-column options-biggest-column selected-country" @click="this.$helper.addFocus">
        <select class="country-select" :class="`${inputType}_country_input disabled_${disabled}`" :disabled="disabled">
            <option></option>
        </select>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            searching: false,
            selectedText: '',
            selectedBackgroundImage: '',
            countries: {},
            selectValues: [],
            selected: undefined,
        }
    },
    props: {
        inputType: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    created: function(){
        let vueThis = this;

        vueThis.countries = vueThis.$store.state.countriesList;
        $.each(vueThis.countries, function(index, element){
            vueThis.countries[index]['visible'] = true;
            vueThis.countries[index]['id'] = index;
            vueThis.countries[index]['text'] = vueThis.countries[index]['title'];
            vueThis.countries[index]['search_text'] = `${element.title} ${element.title_en}`;

            vueThis.selectValues.push(vueThis.countries[index]);
        });

        $(function(){
            $(`.${vueThis.inputType}_country_input`).select2({
                width: '100%',
                scrollAfterSelect: true,

                data: vueThis.selectValues,
                templateResult: vueThis.formatState,
                templateSelection: vueThis.formatSelectedState,
                escapeMarkup: function(markup) {
                    return markup;
                },
                dropdownCssClass: 'country-picker',

                matcher: function(params, data) {
                    if ($.trim(params.term) === '') {
                        return data;
                    }

                    if (data.search_text && data.search_text.toLowerCase().includes(params.term.toLowerCase())) {
                        return data;
                    }

                    return null;
                }
            });

            $(`.${vueThis.inputType}_country_input`).on('select2:select', function() {
                vueThis.selectCountry($(this).val());
            });
            
            vueThis.reselectView();
        });
    },
    updated: function(){
        $('.from_country_input').addClass('select2-hidden-accessible');
        $('.to_country_input').addClass('select2-hidden-accessible');
    },
    methods: {
        selectCountry: function(countryIndex, ignoreDisabled=false){
            if(!ignoreDisabled && this.disabled){
                return;
            }

            this.searching = false;
            this.selected = countryIndex;
            this.selectedText = this.countries[countryIndex].title;
            this.selectedBackgroundImage = this.countries[countryIndex].backgroundImage;

            this.$store.state[this.inputType].countryName = this.selectedText;
            this.$store.state[this.inputType].countryId = countryIndex;
            this.$store.state[this.inputType].country = this.countries[countryIndex].country_code.toLowerCase();
            this.$store.state[this.inputType].countryBackgroundImage = this.selectedBackgroundImage

            this.$store.state.awaitingActions.resetShippings = true;
        },
        filterCountries: function(){
            if(this.disabled){
                return;
            }     
            let vueThis = this;
            let searchValue = vueThis.selectedText.toLowerCase();
            $.each(vueThis.countries, function(index, country){
                vueThis.countries[index].visible = (country.title.toLowerCase().search(searchValue) !== -1);
                vueThis.selectValues.push(vueThis.countries[index]);
            });
        },
        reselectView: function(){    
            this.selected = this.$store.state[this.inputType].countryId;
            if(this.countries[this.selected] !== undefined){
                this.country = this.countries[this.selected].country_code.toLowerCase();
                this.selectedText = this.countries[this.selected].title;
                this.selectedBackgroundImage = this.countries[this.selected].backgroundImage;
                $(`.${this.inputType}_country_input`).val(this.selected).trigger('change.select2');
            } else{
                this.country = '';
                this.selectedText = '';
                this.selectedBackgroundImage = '';
                $(`.${this.inputType}_country_input`).val(null).trigger('change.select2');
            }
        },
        formatState: function(country) {
            if(country.id === '' || country.id === undefined) {
                return;
            }
            
            let imgUrl = '';
            if(country.backgroundImage){
                imgUrl = `background-image: url(\'${country.backgroundImage}\')`;
            }

            return `<div style="display: flex; align-items: center; padding-bottom: 5px; padding-top: 5px;">
                        <span class="flag" style="padding-right: 10px; ${imgUrl}"></span>
                        <span class="country-label" style="padding-left: 10px;">${country.title || this.$helper.trans('Country')}</span>
                    </div>`;
        },
        formatSelectedState: function(country) {
            let imgUrl = '';
            if(country.backgroundImage){
                imgUrl = `background-image: url(\'${country.backgroundImage}\')`;
            }

            return `<div style="display: flex; align-items: center;">
                        <span class="flag selected-flag" style="padding-right: 10px; ${imgUrl}"></span>
                        <span class="country-label selected-country" style="padding-left: 40px;">${country.title || this.$helper.trans('Country')}</span>
                    </div>`;
        },
    },
    watch:{
        disabled: function(){
            this.reselectView();
        },
        '$store.state.awaitingActions.reselectCountries.to': function(){
            if(this.inputType !== 'to' || !this.$store.state.awaitingActions.reselectCountries.to){
                return;
            }
            this.$store.state.awaitingActions.reselectCountries.to = false;
            
            if(this.countries[this.$store.state.to.countryId] !== undefined){
                this.selectCountry(this.$store.state.to.countryId, true);
                $('.to_country_input').val(this.$store.state.to.countryId).trigger('change.select2');
            }
        },
        '$store.state.awaitingActions.reselectCountries.from': function(){
            if(this.inputType !== 'from' || !this.$store.state.awaitingActions.reselectCountries.from){
                return;
            }
            this.$store.state.awaitingActions.reselectCountries.from = false;

            if(this.countries[this.$store.state.from.countryId] !== undefined){
                this.selectCountry(this.$store.state.from.countryId, true);
                $('.from_country_input').val(this.$store.state.from.countryId).trigger('change.select2');
            }
        },
        '$store.state.from' : function(){
            $('.from_country_input').val(this.$store.state.from.countryId).trigger('change.select2');
        },
        '$store.state.to' : function(){
            $('.to_country_input').val(this.$store.state.to.countryId).trigger('change.select2');
        }
    }
}
</script>
